import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '项目文档',
    type: 'CAT_DOC',
}
